import React from 'react';
import { connect } from 'react-redux';

import { Section } from '../../ContentEdit';

//TODO: remove logic that filters bidTasks for each summary card.
const Summary = ({ classes, invoice, preview }) => {

  return(
    <Section
      preview={preview}
      title="Summary"
      showContent={true}
      showAdd={false}>
      <div>summary section</div>
    </Section>
  );
};

Summary.defaultProps = {
  invoice: {
    template: {}
  }
};

const mapStateToProps = (state) => {
  const invoice = state.invoicesState.find(invoice => invoice.id === state.adminState.invoice.id);

  return {
    invoice: invoice,
  }
};

export default connect(mapStateToProps)(Summary);



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/Detail/Summary.jsx